import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=5fe3a163&scoped=true"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&id=5fe3a163&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3a163",
  null
  
)

export default component.exports